import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import chunk from 'lodash.chunk';
import values from 'lodash.values';
import Topic from './Topic';
import styles from './topics.module.scss';

const videoTopic = {
  id: 'videos',
  articleCount: 1,
  name: 'Top Videos',
  href: '/videos',
  description: 'Learn fast with these helpful videos.',
};

const Topics = ({categories}) => {
  const categoryArray = values(categories);
  categoryArray.unshift(videoTopic); // add curated topic for videos

  const chunks = chunk(categoryArray, 3);

  return (
    <section className="section">
      <div className="container container-960">
        <h1 className={classNames('is-size-3', styles.Topics__heading)}>
          Browse by Topic
        </h1>
        {chunks.map((group, i) => (
          <div className="columns" key={i}>
            {group.map(category => (
              <Topic category={category} key={category.id} />
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

Topics.propTypes = {
  categories: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      articleCount: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      description: PropTypes.string,
    }).isRequired
  ).isRequired,
};

export default Topics;



// WEBPACK FOOTER //
// ./src/components/topics/index.js